import { FlightOffer } from '@/src/types/flightOffer'

/**
 * Extracts the offer slug from an offer link URL.
 * e.g. "/en/offers/some-slug" or "/offers/some-slug?lng=ar" → "some-slug"
 */
export const getOfferSlugFromLink = (link: string): string => {
    const parts = link.split('/offers/')
    if (parts.length > 1) {
        return parts[1].split('?')[0].split('/')[0]
    }
    return ''
}

export const fromBase64 = (b64: string): string => {
    if (!b64) return ''

    const base64Regex = /^[A-Za-z0-9+/]*={0,2}$/
    if (!base64Regex.test(b64)) {
        return b64
    }

    try {
        const binary = atob(b64)
        const bytes = new Uint8Array(binary.length)
        for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i)
        return new TextDecoder().decode(bytes)
    } catch (e) {
        // If decoding fails, return the original value
        return b64
    }
}

const errorOffer = (offerSlug: string): FlightOffer => ({
    offerId: offerSlug,
    title: 'Offer Details',
    description: 'Offer information not available',
    imageUrl: '',
    desktopImageUrl: '',
    mobileImageUrl: '',
    isActive: false,
    error: true
})

/**
 * Transforms raw offer API response into a FlightOffer.
 * Shared between server-side getOfferData and client-side RTK Query getOfferDetail.
 */
export function transformOfferDetailResponse(data: any, offerSlug: string, locale: string): FlightOffer {
    if (data.result && data.result.offer) {
        const offer = data.result.offer
        const isArabic = locale === 'ar'
        const translation = isArabic ? offer.ar : offer.en

        const desktopImageUrl = translation.desktopImage || translation.mobileImage || ''
        const mobileImageUrl = translation.mobileImage || desktopImageUrl || ''

        return {
            offerId: offer._id || offerSlug,
            title: translation.cardTitle,
            heading: translation.heading,
            description: translation.cardDescription,
            paragraph: fromBase64(translation.paragraph),
            imageUrl: mobileImageUrl,
            desktopImageUrl,
            mobileImageUrl,
            expiryDate: offer.expiryDate,
            travelPeriod: translation.travelPeriod,
            bookingPeriod: translation.bookingPeriod,
            termsAndConditions: translation.termsAndCondition || [],
            tables: translation.tables || [],
            link: offer.cardLink,
            priority: offer.offerSequence,
            isActive: offer.offerStatus === 'active',
            slug: offer.offerSlug,
            couponCode: offer.code,
            bookNowUrl: offer.bookNowUrl,
            appDownloadBanner: offer.appDownloadBanner,
            error: false
        }
    }

    return errorOffer(offerSlug)
}
